export const GET_MOVIES_TRENDING = "GET_MOVIES_TRENDING";

export const GET_ACTORS_TRENDING = "GET_ACTORS_TRENDING";

export const GET_SERIES_TRENDING = "GET_SERIES_TRENDING";

export const MEDIA_TYPE_DETAILS = "MEDIA_TYPE_DETAILS";

export const MEDIA_TYPE_IFRAME = "MEDIA_TYPE_IFRAME";

export const FETCH_MOVIE_POSTERS = "FETCH_MOVIE_POSTERS";

export const FETCH_MOVIE_ACTORS = "FETCH_MOVIE_ACTORS";

export const FETCH_MOVIE_SIMILAR = "FETCH_MOVIE_SIMILAR";

export const FETCH_MOVIE_RECOMMENDATIONS = "FETCH_MOVIE_RECOMMENDATIONS";

export const REGISTER = "REGISTER";

export const LOGIN = "LOGIN";
